/**
 * Do not edit directly, this file was auto-generated.
 */
const tokens = {
    "--t-border-radius-sm": "2px",
    "--t-border-radius-md": "4px",
    "--t-border-radius-lg": "8px",
    "--t-border-radius-xl": "16px",
    "--t-border-radius-round": "56px",
    "--t-border-radius-default": "4px",
    "--t-border-width-default": "1px",
    "--t-border-width-thick": "2px",
    "--t-border-size-default": "1px",
    "--t-border-size-thick": "2px",
    "--t-spacing-1": "8px",
    "--t-spacing-2": "16px",
    "--t-spacing-3": "24px",
    "--t-spacing-4": "32px",
    "--t-spacing-5": "40px",
    "--t-spacing-6": "48px",
    "--t-spacing-7": "56px",
    "--t-spacing-fourth": "2px",
    "--t-spacing-half": "4px",
    "--t-element-size-3xl": "48px",
    "--t-element-size-2xl": "32px",
    "--t-element-size-xl": "24px",
    "--t-element-size-lg": "18px",
    "--t-element-size-md": "16px",
    "--t-element-size-sm": "14px",
    "--t-element-size-xs": "12px",
    "--t-font-size-4xl": "32px",
    "--t-font-size-3xl": "28px",
    "--t-font-size-2xl": "24px",
    "--t-font-size-xl": "20px",
    "--t-font-size-lg": "18px",
    "--t-font-size-md": "16px",
    "--t-font-size-sm": "14px",
    "--t-font-size-xs": "12px",
    "--t-font-size-2xs": "10px",
    "--t-font-weight-normal": "400",
    "--t-font-weight-medium": "500",
    "--t-font-weight-semibold": "600",
    "--t-font-weight-bold": "700",
    "--t-font-weight-semi-bold": "600",
    "--t-container-size-xl": "48px",
    "--t-container-size-lg": "40px",
    "--t-container-size-md": "32px",
    "--t-container-size-sm": "24px",
    "--t-container-size-xs": "20px",
    "--t-avatar-size-20": "20px",
    "--t-avatar-size-24": "24px",
    "--t-avatar-size-36": "36px",
    "--t-avatar-size-48": "48px",
    "--t-avatar-size-72": "72px",
    "--t-avatar-size-112": "112px",
    "--t-text-color-default-headline": "hsl(0, 0%, 12%)",
    "--t-text-color-default-primary": "hsl(0, 0%, 24%)",
    "--t-text-color-default-secondary": "hsl(0, 0%, 42%)",
    "--t-text-color-default-disabled": "hsl(0, 0%, 81%)",
    "--t-text-color-default-placeholder": "hsl(0, 0%, 58%)",
    "--t-text-color-default-inverted": "hsl(0, 0%, 100%)",
    "--t-text-color-interaction-primary": "hsl(204, 100%, 40%)",
    "--t-text-color-interaction-hover": "hsl(204, 100%, 35%)",
    "--t-text-color-interaction-active": "hsl(204, 100%, 30%)",
    "--t-text-color-interaction-visited": "hsl(204, 100%, 30%)",
    "--t-text-color-status-neutral": "hsl(0, 0%, 24%)",
    "--t-text-color-status-info": "hsl(204, 100%, 35%)",
    "--t-text-color-status-success": "hsl(97, 57%, 28%)",
    "--t-text-color-status-warning": "hsl(42, 100%, 29%)",
    "--t-text-color-status-error": "hsl(8, 60%, 45%)",
    "--t-text-color-tag-subtle-gray": "hsl(0, 0%, 24%)",
    "--t-text-color-tag-subtle-blue": "hsl(224, 47%, 31%)",
    "--t-text-color-tag-subtle-indigo": "hsl(241, 59%, 28%)",
    "--t-text-color-tag-subtle-aqua": "hsl(209, 77%, 22%)",
    "--t-text-color-tag-subtle-teal": "hsl(180, 95%, 15%)",
    "--t-text-color-tag-subtle-green": "hsl(100, 93%, 17%)",
    "--t-text-color-tag-subtle-yellow": "hsl(29, 100%, 23%)",
    "--t-text-color-tag-subtle-orange": "hsl(18, 100%, 18%)",
    "--t-text-color-tag-subtle-pink": "hsl(327, 88%, 20%)",
    "--t-text-color-tag-subtle-purple": "hsl(268, 71%, 27%)",
    "--t-text-color-tag-subtle-magenta": "hsl(285, 71%, 20%)",
    "--t-text-color-tag-gray": "hsl(0, 0%, 24%)",
    "--t-text-color-tag-magenta": "hsl(285, 71%, 20%)",
    "--t-text-color-tag-blue": "hsl(224, 47%, 31%)",
    "--t-text-color-tag-aqua": "hsl(209, 77%, 22%)",
    "--t-text-color-tag-teal": "hsl(180, 95%, 15%)",
    "--t-text-color-tag-green": "hsl(100, 93%, 17%)",
    "--t-text-color-tag-yellow": "hsl(29, 100%, 23%)",
    "--t-text-color-tag-orange": "hsl(18, 100%, 18%)",
    "--t-text-color-tag-pink": "hsl(327, 88%, 20%)",
    "--t-text-color-tag-purple": "hsl(268, 71%, 27%)",
    "--t-text-color-tag-bold-gray": "hsl(0, 0%, 24%)",
    "--t-text-color-tag-bold-indigo": "hsl(241, 59%, 28%)",
    "--t-text-color-tag-bold-blue": "hsl(224, 47%, 31%)",
    "--t-text-color-tag-bold-aqua": "hsl(209, 77%, 22%)",
    "--t-text-color-tag-bold-teal": "hsl(180, 95%, 15%)",
    "--t-text-color-tag-bold-green": "hsl(100, 93%, 17%)",
    "--t-text-color-tag-bold-yellow": "hsl(29, 100%, 23%)",
    "--t-text-color-tag-bold-orange": "hsl(18, 100%, 18%)",
    "--t-text-color-tag-bold-pink": "hsl(327, 88%, 20%)",
    "--t-text-color-tag-bold-purple": "hsl(268, 71%, 27%)",
    "--t-text-color-tag-bold-magenta": "hsl(285, 71%, 20%)",
    "--t-icon-color-default-primary": "hsl(0, 0%, 24%)",
    "--t-icon-color-default-secondary": "hsl(0, 0%, 42%)",
    "--t-icon-color-default-dim": "hsl(0, 0%, 58%)",
    "--t-icon-color-default-disabled": "hsl(0, 0%, 81%)",
    "--t-icon-color-default-inverted": "hsl(0, 0%, 100%)",
    "--t-icon-color-status-neutral-primary": "hsl(0, 0%, 42%)",
    "--t-icon-color-status-neutral-secondary": "hsl(0, 0%, 58%)",
    "--t-icon-color-status-neutral-bold": "hsl(0, 0%, 24%)",
    "--t-icon-color-status-neutral-dark": "hsl(0, 0%, 24%)",
    "--t-icon-color-status-info-primary": "hsl(204, 100%, 40%)",
    "--t-icon-color-status-info-secondary": "hsl(204, 100%, 40%)",
    "--t-icon-color-status-success-primary": "hsl(96, 57%, 33%)",
    "--t-icon-color-status-success-secondary": "hsl(97, 57%, 40%)",
    "--t-icon-color-status-warning-primary": "hsl(42, 84%, 49%)",
    "--t-icon-color-status-error-primary": "hsl(8, 60%, 47%)",
    "--t-fill-color-neutral-000": "hsl(0, 0%, 12%)",
    "--t-fill-color-neutral-010": "hsl(0, 0%, 24%)",
    "--t-fill-color-neutral-020": "hsl(0, 0%, 42%)",
    "--t-fill-color-neutral-025": "hsl(0, 0%, 50%)",
    "--t-fill-color-neutral-030": "hsl(0, 0%, 58%)",
    "--t-fill-color-neutral-040": "hsl(0, 0%, 81%)",
    "--t-fill-color-neutral-050": "hsl(0, 0%, 88%)",
    "--t-fill-color-neutral-060": "hsl(0, 0%, 93%)",
    "--t-fill-color-neutral-070": "hsl(0, 0%, 95%)",
    "--t-fill-color-neutral-080": "hsl(0, 0%, 97%)",
    "--t-fill-color-neutral-090": "hsl(0, 0%, 98%)",
    "--t-fill-color-neutral-100": "hsl(0, 0%, 100%)",
    "--t-fill-color-interaction-default": "hsl(204, 100%, 40%)",
    "--t-fill-color-interaction-hover": "hsl(204, 100%, 35%)",
    "--t-fill-color-interaction-active": "hsl(204, 100%, 30%)",
    "--t-fill-color-interaction-disabled": "hsl(0, 0%, 81%)",
    "--t-fill-color-control-neutral-off": "hsl(0, 0%, 58%)",
    "--t-fill-color-control-neutral-on": "hsl(0, 0%, 24%)",
    "--t-fill-color-control-primary": "hsl(204, 100%, 40%)",
    "--t-fill-color-control-secondary": "hsl(97, 57%, 40%)",
    "--t-fill-color-control-error": "hsl(8, 60%, 47%)",
    "--t-fill-color-control-disabled": "hsl(0, 0%, 81%)",
    "--t-fill-color-status-neutral-solid": "hsl(0, 0%, 42%)",
    "--t-fill-color-status-neutral-ghost": "hsl(0, 0%, 93%)",
    "--t-fill-color-status-neutral-dim": "hsl(0, 0%, 97%)",
    "--t-fill-color-status-info-solid": "hsl(204, 100%, 40%)",
    "--t-fill-color-status-info-ghost": "hsl(203, 94%, 94%)",
    "--t-fill-color-status-info-dim": "hsl(204, 100%, 97%)",
    "--t-fill-color-status-success-solid": "hsl(96, 57%, 33%)",
    "--t-fill-color-status-success-ghost": "hsl(97, 57%, 90%)",
    "--t-fill-color-status-success-dim": "hsl(96, 60%, 95%)",
    "--t-fill-color-status-warning-solid": "hsl(42, 84%, 63%)",
    "--t-fill-color-status-warning-ghost": "hsl(42, 87%, 94%)",
    "--t-fill-color-status-warning-dim": "hsl(42, 87%, 97%)",
    "--t-fill-color-status-error-solid": "hsl(8, 60%, 47%)",
    "--t-fill-color-status-error-ghost": "hsl(9, 59%, 93%)",
    "--t-fill-color-status-error-dim": "hsl(7, 60%, 97%)",
    "--t-fill-color-alert-info": "hsl(204, 94%, 49%)",
    "--t-fill-color-alert-success": "hsl(122, 60%, 41%)",
    "--t-fill-color-alert-warning": "hsl(43, 96%, 58%)",
    "--t-fill-color-alert-error": "hsl(4, 77%, 59%)",
    "--t-fill-color-tooltip-primary": "hsla(0, 0%, 12%, 0.77)",
    "--t-fill-color-product-accounts-010": "hsl(212, 54%, 93%)",
    "--t-fill-color-product-accounts-020": "hsl(209, 53%, 90%)",
    "--t-fill-color-product-accounts-030": "hsl(210, 56%, 70%)",
    "--t-fill-color-product-accounts-040": "hsl(210, 54%, 60%)",
    "--t-fill-color-product-accounts-050": "hsl(210, 55%, 50%)",
    "--t-fill-color-product-accounts-060": "hsl(210, 65%, 40%)",
    "--t-fill-color-product-accounts-070": "hsl(211, 70%, 32%)",
    "--t-fill-color-product-accounts-080": "hsl(210, 75%, 25%)",
    "--t-fill-color-product-calendar-010": "hsl(8, 61%, 90%)",
    "--t-fill-color-product-calendar-020": "hsl(8, 61%, 70%)",
    "--t-fill-color-product-calendar-030": "hsl(8, 72%, 59%)",
    "--t-fill-color-product-calendar-040": "hsl(8, 65%, 55%)",
    "--t-fill-color-product-calendar-050": "hsl(9, 61%, 50%)",
    "--t-fill-color-product-calendar-060": "hsl(8, 65%, 42%)",
    "--t-fill-color-product-calendar-070": "hsl(7, 65%, 34%)",
    "--t-fill-color-product-calendar-080": "hsl(9, 61%, 27%)",
    "--t-fill-color-product-checkins-010": "hsl(285, 20%, 92%)",
    "--t-fill-color-product-checkins-020": "hsl(283, 22%, 75%)",
    "--t-fill-color-product-checkins-030": "hsl(284, 22%, 64%)",
    "--t-fill-color-product-checkins-040": "hsl(283, 22%, 55%)",
    "--t-fill-color-product-checkins-050": "hsl(283, 22%, 48%)",
    "--t-fill-color-product-checkins-060": "hsl(283, 27%, 42%)",
    "--t-fill-color-product-checkins-070": "hsl(284, 33%, 34%)",
    "--t-fill-color-product-checkins-080": "hsl(283, 33%, 27%)",
    "--t-fill-color-product-giving-010": "hsl(41, 95%, 93%)",
    "--t-fill-color-product-giving-020": "hsl(42, 95%, 83%)",
    "--t-fill-color-product-giving-030": "hsl(43, 95%, 75%)",
    "--t-fill-color-product-giving-040": "hsl(43, 88%, 70%)",
    "--t-fill-color-product-giving-050": "hsl(43, 88%, 64%)",
    "--t-fill-color-product-giving-060": "hsl(42, 84%, 55%)",
    "--t-fill-color-product-giving-070": "hsl(42, 84%, 48%)",
    "--t-fill-color-product-giving-080": "hsl(42, 100%, 40%)",
    "--t-fill-color-product-groups-010": "hsl(18, 95%, 92%)",
    "--t-fill-color-product-groups-020": "hsl(17, 96%, 80%)",
    "--t-fill-color-product-groups-030": "hsl(17, 96%, 70%)",
    "--t-fill-color-product-groups-040": "hsl(17, 96%, 63%)",
    "--t-fill-color-product-groups-050": "hsl(17, 88%, 55%)",
    "--t-fill-color-product-groups-060": "hsl(12, 70%, 48%)",
    "--t-fill-color-product-groups-070": "hsl(12, 70%, 40%)",
    "--t-fill-color-product-groups-080": "hsl(14, 70%, 34%)",
    "--t-fill-color-product-home-010": "hsl(221, 89%, 93%)",
    "--t-fill-color-product-home-020": "hsl(221, 91%, 91%)",
    "--t-fill-color-product-home-030": "hsl(221, 91%, 87%)",
    "--t-fill-color-product-home-040": "hsl(221, 91%, 62%)",
    "--t-fill-color-product-home-050": "hsl(221, 91%, 55%)",
    "--t-fill-color-product-home-060": "hsl(221, 90%, 50%)",
    "--t-fill-color-product-home-070": "hsl(221, 90%, 45%)",
    "--t-fill-color-product-home-080": "hsl(218, 84%, 25%)",
    "--t-fill-color-product-people-010": "hsl(219, 73%, 91%)",
    "--t-fill-color-product-people-020": "hsl(220, 69%, 81%)",
    "--t-fill-color-product-people-030": "hsl(221, 73%, 71%)",
    "--t-fill-color-product-people-040": "hsl(221, 73%, 65%)",
    "--t-fill-color-product-people-050": "hsl(220, 74%, 57%)",
    "--t-fill-color-product-people-060": "hsl(220, 68%, 51%)",
    "--t-fill-color-product-people-070": "hsl(220, 68%, 41%)",
    "--t-fill-color-product-people-080": "hsl(221, 68%, 31%)",
    "--t-fill-color-product-publishing-010": "hsl(220, 4%, 86%)",
    "--t-fill-color-product-publishing-020": "hsl(222, 10%, 60%)",
    "--t-fill-color-product-publishing-030": "hsl(221, 11%, 50%)",
    "--t-fill-color-product-publishing-040": "hsl(222, 12%, 39%)",
    "--t-fill-color-product-publishing-050": "hsl(220, 12%, 31%)",
    "--t-fill-color-product-publishing-060": "hsl(220, 11%, 26%)",
    "--t-fill-color-product-publishing-070": "hsl(217, 12%, 22%)",
    "--t-fill-color-product-publishing-080": "hsl(214, 11%, 12%)",
    "--t-fill-color-product-registrations-010": "hsl(173, 28%, 89%)",
    "--t-fill-color-product-registrations-020": "hsl(176, 38%, 78%)",
    "--t-fill-color-product-registrations-030": "hsl(176, 37%, 68%)",
    "--t-fill-color-product-registrations-040": "hsl(176, 37%, 60%)",
    "--t-fill-color-product-registrations-050": "hsl(175, 36%, 43%)",
    "--t-fill-color-product-registrations-060": "hsl(175, 51%, 34%)",
    "--t-fill-color-product-registrations-070": "hsl(174, 51%, 28%)",
    "--t-fill-color-product-registrations-080": "hsl(175, 52%, 22%)",
    "--t-fill-color-product-services-010": "hsl(88, 31%, 88%)",
    "--t-fill-color-product-services-020": "hsl(88, 39%, 75%)",
    "--t-fill-color-product-services-030": "hsl(88, 39%, 66%)",
    "--t-fill-color-product-services-040": "hsl(88, 40%, 54%)",
    "--t-fill-color-product-services-050": "hsl(88, 45%, 41%)",
    "--t-fill-color-product-services-060": "hsl(89, 62%, 31%)",
    "--t-fill-color-product-services-070": "hsl(89, 62%, 26%)",
    "--t-fill-color-product-services-080": "hsl(89, 63%, 21%)",
    "--t-fill-color-product-accounts-lightest": "hsl(212, 54%, 93%)",
    "--t-fill-color-product-accounts-lighter": "hsl(209, 53%, 90%)",
    "--t-fill-color-product-accounts-light": "hsl(210, 54%, 60%)",
    "--t-fill-color-product-accounts-base": "hsl(210, 55%, 50%)",
    "--t-fill-color-product-accounts-dark": "hsl(210, 65%, 40%)",
    "--t-fill-color-product-accounts-darker": "hsl(211, 70%, 32%)",
    "--t-fill-color-product-accounts-darkest": "hsl(210, 75%, 25%)",
    "--t-fill-color-product-calendar-lightest": "hsl(8, 61%, 70%)",
    "--t-fill-color-product-calendar-lighter": "hsl(8, 72%, 59%)",
    "--t-fill-color-product-calendar-light": "hsl(8, 65%, 55%)",
    "--t-fill-color-product-calendar-base": "hsl(9, 61%, 50%)",
    "--t-fill-color-product-calendar-dark": "hsl(8, 65%, 42%)",
    "--t-fill-color-product-calendar-darker": "hsl(7, 65%, 34%)",
    "--t-fill-color-product-calendar-darkest": "hsl(9, 61%, 27%)",
    "--t-fill-color-product-checkins-lightest": "hsl(283, 22%, 75%)",
    "--t-fill-color-product-checkins-lighter": "hsl(284, 22%, 64%)",
    "--t-fill-color-product-checkins-light": "hsl(283, 22%, 55%)",
    "--t-fill-color-product-checkins-base": "hsl(283, 22%, 48%)",
    "--t-fill-color-product-checkins-dark": "hsl(283, 27%, 42%)",
    "--t-fill-color-product-checkins-darker": "hsl(284, 33%, 34%)",
    "--t-fill-color-product-checkins-darkest": "hsl(283, 33%, 27%)",
    "--t-fill-color-product-giving-lightest": "hsl(42, 95%, 83%)",
    "--t-fill-color-product-giving-lighter": "hsl(43, 95%, 75%)",
    "--t-fill-color-product-giving-light": "hsl(43, 88%, 70%)",
    "--t-fill-color-product-giving-base": "hsl(43, 88%, 64%)",
    "--t-fill-color-product-giving-dark": "hsl(42, 84%, 55%)",
    "--t-fill-color-product-giving-darker": "hsl(42, 84%, 48%)",
    "--t-fill-color-product-giving-darkest": "hsl(42, 100%, 40%)",
    "--t-fill-color-product-groups-lightest": "hsl(17, 96%, 80%)",
    "--t-fill-color-product-groups-lighter": "hsl(17, 96%, 70%)",
    "--t-fill-color-product-groups-light": "hsl(17, 96%, 63%)",
    "--t-fill-color-product-groups-base": "hsl(17, 88%, 55%)",
    "--t-fill-color-product-groups-dark": "hsl(12, 70%, 48%)",
    "--t-fill-color-product-groups-darker": "hsl(12, 70%, 40%)",
    "--t-fill-color-product-groups-darkest": "hsl(14, 70%, 34%)",
    "--t-fill-color-product-home-lightest": "hsl(221, 91%, 91%)",
    "--t-fill-color-product-home-lighter": "hsl(221, 91%, 87%)",
    "--t-fill-color-product-home-light": "hsl(221, 91%, 62%)",
    "--t-fill-color-product-home-base": "hsl(221, 91%, 55%)",
    "--t-fill-color-product-home-dark": "hsl(221, 90%, 50%)",
    "--t-fill-color-product-home-darker": "hsl(221, 90%, 45%)",
    "--t-fill-color-product-home-darkest": "hsl(218, 84%, 25%)",
    "--t-fill-color-product-people-lightest": "hsl(220, 69%, 81%)",
    "--t-fill-color-product-people-lighter": "hsl(221, 73%, 71%)",
    "--t-fill-color-product-people-light": "hsl(221, 73%, 65%)",
    "--t-fill-color-product-people-base": "hsl(220, 74%, 57%)",
    "--t-fill-color-product-people-dark": "hsl(220, 68%, 51%)",
    "--t-fill-color-product-people-darker": "hsl(220, 68%, 41%)",
    "--t-fill-color-product-people-darkest": "hsl(221, 68%, 31%)",
    "--t-fill-color-product-publishing-lightest": "hsl(222, 10%, 60%)",
    "--t-fill-color-product-publishing-lighter": "hsl(221, 11%, 50%)",
    "--t-fill-color-product-publishing-light": "hsl(222, 12%, 39%)",
    "--t-fill-color-product-publishing-base": "hsl(220, 12%, 31%)",
    "--t-fill-color-product-publishing-dark": "hsl(220, 11%, 26%)",
    "--t-fill-color-product-publishing-darker": "hsl(217, 12%, 22%)",
    "--t-fill-color-product-publishing-darkest": "hsl(214, 11%, 12%)",
    "--t-fill-color-product-registrations-lightest": "hsl(176, 38%, 78%)",
    "--t-fill-color-product-registrations-lighter": "hsl(176, 37%, 68%)",
    "--t-fill-color-product-registrations-light": "hsl(176, 37%, 60%)",
    "--t-fill-color-product-registrations-base": "hsl(175, 36%, 43%)",
    "--t-fill-color-product-registrations-dark": "hsl(175, 51%, 34%)",
    "--t-fill-color-product-registrations-darker": "hsl(174, 51%, 28%)",
    "--t-fill-color-product-registrations-darkest": "hsl(175, 52%, 22%)",
    "--t-fill-color-product-services-lightest": "hsl(88, 39%, 75%)",
    "--t-fill-color-product-services-lighter": "hsl(88, 39%, 66%)",
    "--t-fill-color-product-services-light": "hsl(88, 40%, 54%)",
    "--t-fill-color-product-services-base": "hsl(88, 45%, 41%)",
    "--t-fill-color-product-services-dark": "hsl(89, 62%, 31%)",
    "--t-fill-color-product-services-darker": "hsl(89, 62%, 26%)",
    "--t-fill-color-product-services-darkest": "hsl(89, 63%, 21%)",
    "--t-fill-color-product-staff-base": "hsl(328, 100%, 45%)",
    "--t-fill-color-product-staff-dark": "hsl(328, 100%, 38%)",
    "--t-fill-color-product-staff-darker": "hsl(328, 100%, 33%)",
    "--t-fill-color-product-accounts-gradient-brand": "linear-gradient(135deg, hsl(203, 86%, 57%), hsl(220, 76%, 57%))",
    "--t-fill-color-product-accounts-gradient-page": "linear-gradient(111.72deg, hsl(220, 73%, 81%), hsl(220, 73%, 81%), hsl(204, 67%, 73%))",
    "--t-fill-color-product-accounts-gradient-tint": "linear-gradient(111.72deg, hsl(218, 73%, 94%), hsl(218, 73%, 94%), hsl(204, 67%, 92%))",
    "--t-fill-color-product-api-gradient-brand": "linear-gradient(180deg, hsl(221, 100%, 62%), hsl(217, 100%, 52%))",
    "--t-fill-color-product-calendar-gradient-brand": "linear-gradient(135deg, hsl(10, 88%, 58%), hsl(8, 60%, 51%))",
    "--t-fill-color-product-calendar-gradient-page": "linear-gradient(111.72deg, hsl(5, 80%, 80%), hsl(293, 13%, 74%), hsl(204, 67%, 73%))",
    "--t-fill-color-product-calendar-gradient-tint": "linear-gradient(111.72deg, hsl(8, 100%, 94%), hsl(285, 18%, 91%), hsl(204, 67%, 92%))",
    "--t-fill-color-product-cc-gradient-brand": "linear-gradient(135deg, hsl(207, 90%, 61%), hsl(123, 38%, 57%))",
    "--t-fill-color-product-checkins-gradient-brand": "linear-gradient(135deg, hsl(283, 38%, 59%), hsl(284, 23%, 48%))",
    "--t-fill-color-product-checkins-gradient-page": "linear-gradient(111.72deg, hsl(283, 21%, 77%) 25%, hsl(227, 36%, 78%) 60%, hsl(204, 67%, 73%))",
    "--t-fill-color-product-checkins-gradient-tint": "linear-gradient(111.72deg, hsl(285, 22%, 93%), hsl(225, 35%, 93%) 42%, hsl(204, 67%, 92%))",
    "--t-fill-color-product-giving-gradient-brand": "linear-gradient(90deg, hsl(46, 91%, 55%), hsl(41, 89%, 55%))",
    "--t-fill-color-product-giving-gradient-page": "linear-gradient(111.72deg, hsl(42, 84%, 80%), hsl(255, 21%, 89%) 58.5%, hsl(204, 67%, 73%))",
    "--t-fill-color-product-giving-gradient-tint": "linear-gradient(111.72deg, hsl(42, 87%, 94%), hsl(260, 18%, 97%) 58.5%, hsl(204, 67%, 92%))",
    "--t-fill-color-product-groups-gradient-brand": "linear-gradient(135deg, hsl(30, 100%, 59%), hsl(19, 97%, 60%))",
    "--t-fill-color-product-groups-gradient-page": "linear-gradient(111.72deg, hsl(17, 88%, 80%), hsl(293, 13%, 74%), hsl(204, 67%, 73%))",
    "--t-fill-color-product-groups-gradient-tint": "linear-gradient(111.72deg, hsl(18, 87%, 94%), hsl(300, 12%, 92%), hsl(204, 67%, 92%))",
    "--t-fill-color-product-headcounts-gradient-brand": "linear-gradient(135deg, hsl(283, 37%, 59%), hsl(285, 23%, 47%))",
    "--t-fill-color-product-home-gradient-page": "linear-gradient(111.72deg, hsl(220, 73%, 81%), hsl(220, 73%, 81%), hsl(204, 67%, 73%))",
    "--t-fill-color-product-home-gradient-tint": "linear-gradient(111.72deg, hsl(218, 73%, 94%), hsl(218, 73%, 94%), hsl(204, 67%, 92%))",
    "--t-fill-color-product-musicstand-gradient-brand": "linear-gradient(135deg, hsl(204, 64%, 51%), hsl(211, 55%, 51%))",
    "--t-fill-color-product-people-gradient-brand": "linear-gradient(135deg, hsl(205, 86%, 57%), hsl(220, 76%, 57%))",
    "--t-fill-color-product-people-gradient-page": "linear-gradient(111.72deg, hsl(220, 73%, 81%), hsl(220, 73%, 81%), hsl(204, 67%, 73%))",
    "--t-fill-color-product-people-gradient-tint": "linear-gradient(111.72deg, hsl(218, 73%, 94%), hsl(218, 73%, 94%), hsl(204, 67%, 92%))",
    "--t-fill-color-product-publishing-gradient-brand": "linear-gradient(135deg, hsl(240, 4%, 49%), hsl(240, 6%, 39%))",
    "--t-fill-color-product-publishing-gradient-page": "linear-gradient(111.72deg, hsl(217, 5%, 69%), hsl(214, 15%, 69%) 45%, hsl(204, 67%, 73%))",
    "--t-fill-color-product-publishing-gradient-tint": "linear-gradient(111.72deg, hsl(210, 4%, 91%), hsl(214, 15%, 91%) 45%, hsl(204, 67%, 92%))",
    "--t-fill-color-product-registrations-gradient-brand": "linear-gradient(135deg, hsl(168, 46%, 48%), hsl(175, 35%, 43%))",
    "--t-fill-color-product-registrations-gradient-page": "linear-gradient(111.72deg, hsl(175, 27%, 74%), hsl(196, 46%, 73%) 39.5%, hsl(204, 67%, 73%))",
    "--t-fill-color-product-registrations-gradient-tint": "linear-gradient(111.72deg, hsl(175, 28%, 92%), hsl(196, 46%, 92%) 39.5%, hsl(204, 67%, 92%))",
    "--t-fill-color-product-services-gradient-brand": "linear-gradient(135deg, hsl(96, 49%, 47%), hsl(89, 52%, 39%))",
    "--t-fill-color-product-services-gradient-page": "linear-gradient(111.72deg, hsl(89, 31%, 73%), hsl(122, 29%, 78%) 39.5%, hsl(204, 67%, 73%))",
    "--t-fill-color-product-services-gradient-tint": "linear-gradient(111.72deg, hsl(88, 32%, 92%), hsl(126, 29%, 93%) 39.5%, hsl(204, 67%, 92%))",
    "--t-fill-color-tag-gray-010": "hsl(0, 0%, 93%)",
    "--t-fill-color-tag-gray-020": "hsl(0, 0%, 88%)",
    "--t-fill-color-tag-gray-030": "hsl(0, 0%, 88%)",
    "--t-fill-color-tag-gray-040": "hsl(0, 0%, 81%)",
    "--t-fill-color-tag-blue-010": "hsl(220, 100%, 95%)",
    "--t-fill-color-tag-blue-020": "hsl(221, 100%, 88%)",
    "--t-fill-color-tag-blue-030": "hsl(220, 98%, 81%)",
    "--t-fill-color-tag-blue-040": "hsl(220, 98%, 74%)",
    "--t-fill-color-tag-aqua-010": "hsl(200, 82%, 89%)",
    "--t-fill-color-tag-aqua-020": "hsl(200, 82%, 82%)",
    "--t-fill-color-tag-aqua-030": "hsl(201, 76%, 71%)",
    "--t-fill-color-tag-aqua-040": "hsl(200, 75%, 64%)",
    "--t-fill-color-tag-teal-010": "hsl(163, 53%, 83%)",
    "--t-fill-color-tag-teal-020": "hsl(164, 52%, 76%)",
    "--t-fill-color-tag-teal-030": "hsl(169, 62%, 64%)",
    "--t-fill-color-tag-teal-040": "hsl(169, 62%, 56%)",
    "--t-fill-color-tag-green-010": "hsl(98, 59%, 85%)",
    "--t-fill-color-tag-green-020": "hsl(99, 59%, 78%)",
    "--t-fill-color-tag-green-030": "hsl(112, 57%, 65%)",
    "--t-fill-color-tag-green-040": "hsl(112, 57%, 57%)",
    "--t-fill-color-tag-yellow-010": "hsl(45, 77%, 85%)",
    "--t-fill-color-tag-yellow-020": "hsl(44, 78%, 77%)",
    "--t-fill-color-tag-yellow-030": "hsl(44, 92%, 69%)",
    "--t-fill-color-tag-yellow-040": "hsl(44, 93%, 61%)",
    "--t-fill-color-tag-orange-010": "hsl(22, 89%, 89%)",
    "--t-fill-color-tag-orange-020": "hsl(21, 89%, 82%)",
    "--t-fill-color-tag-orange-030": "hsl(21, 86%, 72%)",
    "--t-fill-color-tag-orange-040": "hsl(21, 86%, 64%)",
    "--t-fill-color-tag-pink-010": "hsl(311, 66%, 92%)",
    "--t-fill-color-tag-pink-020": "hsl(310, 64%, 85%)",
    "--t-fill-color-tag-pink-030": "hsl(324, 78%, 77%)",
    "--t-fill-color-tag-pink-040": "hsl(324, 76%, 70%)",
    "--t-fill-color-tag-purple-010": "hsl(259, 74%, 93%)",
    "--t-fill-color-tag-purple-020": "hsl(259, 74%, 85%)",
    "--t-fill-color-tag-purple-030": "hsl(273, 62%, 76%)",
    "--t-fill-color-tag-purple-040": "hsl(273, 62%, 70%)",
    "--t-fill-color-tag-magenta-010": "hsl(294, 37%, 90%)",
    "--t-fill-color-tag-magenta-020": "hsl(291, 40%, 83%)",
    "--t-fill-color-tag-magenta-030": "hsl(291, 48%, 70%)",
    "--t-fill-color-tag-magenta-040": "hsl(292, 48%, 63%)",
    "--t-fill-color-tag-indigo-010": "hsl(234, 78%, 93%)",
    "--t-fill-color-tag-indigo-020": "hsl(233, 79%, 87%)",
    "--t-fill-color-tag-indigo-030": "hsl(233, 77%, 81%)",
    "--t-fill-color-tag-indigo-040": "hsl(236, 79%, 74%)",
    "--t-fill-color-tag-subtle-gray": "hsl(0, 0%, 93%)",
    "--t-fill-color-tag-subtle-blue": "hsl(220, 100%, 95%)",
    "--t-fill-color-tag-subtle-aqua": "hsl(200, 82%, 89%)",
    "--t-fill-color-tag-subtle-teal": "hsl(163, 53%, 83%)",
    "--t-fill-color-tag-subtle-green": "hsl(98, 59%, 85%)",
    "--t-fill-color-tag-subtle-yellow": "hsl(45, 77%, 85%)",
    "--t-fill-color-tag-subtle-orange": "hsl(22, 89%, 89%)",
    "--t-fill-color-tag-subtle-pink": "hsl(311, 66%, 92%)",
    "--t-fill-color-tag-subtle-purple": "hsl(259, 74%, 93%)",
    "--t-fill-color-tag-subtle-magenta": "hsl(294, 37%, 90%)",
    "--t-fill-color-tag-subtle-label-gray": "hsl(0, 0%, 88%)",
    "--t-fill-color-tag-subtle-label-blue": "hsl(221, 100%, 88%)",
    "--t-fill-color-tag-subtle-label-aqua": "hsl(200, 82%, 82%)",
    "--t-fill-color-tag-subtle-label-teal": "hsl(164, 52%, 76%)",
    "--t-fill-color-tag-subtle-label-green": "hsl(99, 59%, 78%)",
    "--t-fill-color-tag-subtle-label-yellow": "hsl(44, 78%, 77%)",
    "--t-fill-color-tag-subtle-label-orange": "hsl(21, 89%, 82%)",
    "--t-fill-color-tag-subtle-label-pink": "hsl(310, 64%, 85%)",
    "--t-fill-color-tag-subtle-label-purple": "hsl(259, 74%, 85%)",
    "--t-fill-color-tag-subtle-label-magenta": "hsl(291, 40%, 83%)",
    "--t-fill-color-tag-bold-gray": "hsl(0, 0%, 88%)",
    "--t-fill-color-tag-bold-blue": "hsl(220, 98%, 81%)",
    "--t-fill-color-tag-bold-aqua": "hsl(201, 76%, 71%)",
    "--t-fill-color-tag-bold-teal": "hsl(169, 62%, 64%)",
    "--t-fill-color-tag-bold-green": "hsl(112, 57%, 65%)",
    "--t-fill-color-tag-bold-yellow": "hsl(44, 92%, 69%)",
    "--t-fill-color-tag-bold-orange": "hsl(21, 86%, 72%)",
    "--t-fill-color-tag-bold-pink": "hsl(324, 78%, 77%)",
    "--t-fill-color-tag-bold-purple": "hsl(273, 62%, 76%)",
    "--t-fill-color-tag-bold-magenta": "hsl(291, 48%, 70%)",
    "--t-fill-color-tag-bold-label-gray": "hsl(0, 0%, 81%)",
    "--t-fill-color-tag-bold-label-blue": "hsl(220, 98%, 74%)",
    "--t-fill-color-tag-bold-label-aqua": "hsl(200, 75%, 64%)",
    "--t-fill-color-tag-bold-label-teal": "hsl(169, 62%, 56%)",
    "--t-fill-color-tag-bold-label-green": "hsl(112, 57%, 57%)",
    "--t-fill-color-tag-bold-label-yellow": "hsl(44, 93%, 61%)",
    "--t-fill-color-tag-bold-label-orange": "hsl(21, 86%, 64%)",
    "--t-fill-color-tag-bold-label-pink": "hsl(324, 76%, 70%)",
    "--t-fill-color-tag-bold-label-purple": "hsl(273, 62%, 70%)",
    "--t-fill-color-tag-bold-label-magenta": "hsl(292, 48%, 63%)",
    "--t-fill-color-button-neutral-solid-default": "hsl(0, 0%, 42%)",
    "--t-fill-color-button-neutral-solid-hover": "hsl(0, 0%, 24%)",
    "--t-fill-color-button-neutral-solid-active": "hsl(0, 0%, 12%)",
    "--t-fill-color-button-neutral-solid-disabled": "hsl(0, 0%, 95%)",
    "--t-fill-color-button-neutral-outline-dim-default": "hsla(0, 0%, 100%, 0)",
    "--t-fill-color-button-neutral-outline-dim-hover": "hsl(0, 0%, 95%)",
    "--t-fill-color-button-neutral-outline-dim-active": "hsl(0, 0%, 93%)",
    "--t-fill-color-button-neutral-outline-dim-disabled": "hsl(0, 0%, 98%)",
    "--t-fill-color-button-neutral-outline-dim-disabled-solid": "hsl(0, 0%, 98%)",
    "--t-fill-color-button-neutral-ghost-default": "hsla(0, 0%, 100%, 0)",
    "--t-fill-color-button-neutral-ghost-hover": "hsl(0, 0%, 95%)",
    "--t-fill-color-button-neutral-ghost-active": "hsl(0, 0%, 93%)",
    "--t-fill-color-button-neutral-ghost-disabled": "hsla(0, 0%, 100%, 0)",
    "--t-fill-color-button-neutral-ghost-disabled-solid": "hsl(0, 0%, 98%)",
    "--t-fill-color-button-neutral-responsive-header-default": "hsla(0, 0%, 0%, 0.1)",
    "--t-fill-color-button-neutral-responsive-header-hover": "hsla(0, 0%, 0%, 0.2)",
    "--t-fill-color-button-neutral-responsive-header-active": "hsla(0, 0%, 0%, 0.3)",
    "--t-fill-color-button-neutral-responsive-header-disabled": "hsla(0, 0%, 0%, 0.05)",
    "--t-fill-color-button-interaction-solid-default": "hsl(204, 100%, 40%)",
    "--t-fill-color-button-interaction-solid-hover": "hsl(204, 100%, 35%)",
    "--t-fill-color-button-interaction-solid-active": "hsl(204, 100%, 30%)",
    "--t-fill-color-button-interaction-solid-disabled": "hsl(0, 0%, 95%)",
    "--t-fill-color-button-interaction-outline-dim-default": "hsla(0, 0%, 100%, 0)",
    "--t-fill-color-button-interaction-outline-dim-hover": "hsl(204, 100%, 97%)",
    "--t-fill-color-button-interaction-outline-dim-active": "hsl(203, 94%, 94%)",
    "--t-fill-color-button-interaction-outline-dim-disabled": "hsl(0, 0%, 98%)",
    "--t-fill-color-button-interaction-ghost-default": "hsla(0, 0%, 100%, 0)",
    "--t-fill-color-button-interaction-ghost-hover": "hsl(204, 100%, 97%)",
    "--t-fill-color-button-interaction-ghost-active": "hsl(203, 94%, 94%)",
    "--t-fill-color-button-interaction-ghost-disabled": "hsla(0, 0%, 100%, 0)",
    "--t-fill-color-button-default-info-solid-default": "hsl(204, 100%, 40%)",
    "--t-fill-color-button-default-info-solid-hover": "hsl(204, 100%, 35%)",
    "--t-fill-color-button-default-info-solid-active": "hsl(204, 100%, 30%)",
    "--t-fill-color-button-default-info-solid-disabled": "hsl(0, 0%, 81%)",
    "--t-fill-color-button-default-info-outline-dim-default": "hsla(0, 0%, 100%, 0)",
    "--t-fill-color-button-default-info-outline-dim-hover": "hsl(204, 100%, 97%)",
    "--t-fill-color-button-default-info-outline-dim-active": "hsl(203, 94%, 94%)",
    "--t-fill-color-button-default-info-outline-dim-disabled": "hsla(0, 0%, 100%, 0)",
    "--t-fill-color-button-default-info-ghost-default": "hsla(0, 0%, 100%, 0)",
    "--t-fill-color-button-default-info-ghost-hover": "hsl(204, 100%, 97%)",
    "--t-fill-color-button-default-info-ghost-active": "hsl(203, 94%, 94%)",
    "--t-fill-color-button-default-info-ghost-disabled": "hsla(0, 0%, 100%, 0)",
    "--t-fill-color-button-create-solid-default": "hsl(96, 57%, 33%)",
    "--t-fill-color-button-create-solid-hover": "hsl(97, 57%, 28%)",
    "--t-fill-color-button-create-solid-active": "hsl(97, 57%, 23%)",
    "--t-fill-color-button-create-solid-disabled": "hsl(0, 0%, 81%)",
    "--t-fill-color-button-create-ghost-default": "hsla(0, 0%, 100%, 0)",
    "--t-fill-color-button-create-ghost-hover": "hsl(96, 60%, 95%)",
    "--t-fill-color-button-create-ghost-active": "hsl(97, 57%, 90%)",
    "--t-fill-color-button-create-ghost-disabled": "hsla(0, 0%, 100%, 0)",
    "--t-fill-color-button-delete-solid-default": "hsl(8, 60%, 47%)",
    "--t-fill-color-button-delete-solid-hover": "hsl(8, 60%, 45%)",
    "--t-fill-color-button-delete-solid-active": "hsl(8, 60%, 40%)",
    "--t-fill-color-button-delete-solid-disabled": "hsl(0, 0%, 95%)",
    "--t-fill-color-button-delete-outline-dim-default": "hsla(0, 0%, 100%, 0)",
    "--t-fill-color-button-delete-outline-dim-hover": "hsl(7, 60%, 97%)",
    "--t-fill-color-button-delete-outline-dim-active": "hsl(9, 59%, 93%)",
    "--t-fill-color-button-delete-outline-dim-disabled": "hsl(0, 0%, 98%)",
    "--t-fill-color-button-delete-ghost-default": "hsla(0, 0%, 100%, 0)",
    "--t-fill-color-button-delete-ghost-hover": "hsl(7, 60%, 97%)",
    "--t-fill-color-button-delete-ghost-active": "hsl(9, 59%, 93%)",
    "--t-fill-color-button-delete-ghost-disabled": "hsla(0, 0%, 100%, 0)",
    "--t-fill-color-button-pill-default": "hsl(0, 0%, 93%)",
    "--t-fill-color-button-pill-hover": "hsl(0, 0%, 88%)",
    "--t-fill-color-button-pill-active": "hsl(0, 0%, 88%)",
    "--t-fill-color-button-pill-disabled": "hsl(0, 0%, 93%)",
    "--t-fill-color-transparency-light-010": "hsla(0, 0%, 100%, 0.1)",
    "--t-fill-color-transparency-light-020": "hsla(0, 0%, 100%, 0.2)",
    "--t-fill-color-transparency-light-030": "hsla(0, 0%, 100%, 0.3)",
    "--t-fill-color-transparency-light-040": "hsla(0, 0%, 100%, 0.4)",
    "--t-fill-color-transparency-light-050": "hsla(0, 0%, 100%, 0.5)",
    "--t-fill-color-transparency-light-060": "hsla(0, 0%, 100%, 0.6)",
    "--t-fill-color-transparency-light-070": "hsla(0, 0%, 100%, 0.7)",
    "--t-fill-color-transparency-light-080": "hsla(0, 0%, 100%, 0.8)",
    "--t-fill-color-transparency-light-090": "hsla(0, 0%, 100%, 0.9)",
    "--t-fill-color-transparency-dark-010": "hsla(0, 0%, 0%, 0.1)",
    "--t-fill-color-transparency-dark-020": "hsla(0, 0%, 0%, 0.2)",
    "--t-fill-color-transparency-dark-030": "hsla(0, 0%, 0%, 0.3)",
    "--t-fill-color-transparency-dark-040": "hsla(0, 0%, 0%, 0.4)",
    "--t-fill-color-transparency-dark-050": "hsla(0, 0%, 0%, 0.5)",
    "--t-fill-color-transparency-dark-060": "hsla(0, 0%, 0%, 0.6)",
    "--t-fill-color-transparency-dark-070": "hsla(0, 0%, 0%, 0.7)",
    "--t-fill-color-transparency-dark-080": "hsla(0, 0%, 0%, 0.8)",
    "--t-fill-color-transparency-dark-090": "hsla(0, 0%, 0%, 0.9)",
    "--t-surface-color-canvas": "hsl(0, 0%, 98%)",
    "--t-surface-color-card": "hsl(0, 0%, 100%)",
    "--t-border-color-default-base": "hsl(0, 0%, 88%)",
    "--t-border-color-default-dark": "hsl(0, 0%, 81%)",
    "--t-border-color-default-darker": "hsl(0, 0%, 68%)",
    "--t-border-color-default-darkest": "hsl(0, 0%, 58%)",
    "--t-border-color-default-disabled": "hsl(0, 0%, 88%)",
    "--t-border-color-default-dim": "hsl(0, 0%, 95%)",
    "--t-border-color-default-white": "hsl(0, 0%, 100%)",
    "--t-border-color-status-neutral": "hsl(0, 0%, 58%)",
    "--t-border-color-status-info": "hsl(204, 100%, 40%)",
    "--t-border-color-status-success": "hsl(97, 57%, 40%)",
    "--t-border-color-status-warning": "hsl(42, 84%, 63%)",
    "--t-border-color-status-error": "hsl(8, 60%, 47%)",
    "--t-border-color-button-neutral": "hsl(0, 0%, 88%)",
    "--t-border-color-button-info": "hsl(204, 100%, 40%)",
    "--t-border-color-button-create": "hsl(96, 57%, 33%)",
    "--t-border-color-button-delete": "hsl(8, 60%, 47%)",
    "--t-border-color-control-neutral": "hsl(0, 0%, 68%)",
    "--t-border-color-control-info": "hsl(204, 100%, 40%)",
    "--t-border-color-control-success": "hsl(97, 57%, 40%)",
    "--t-border-color-control-warning": "hsl(42, 84%, 63%)",
    "--t-border-color-control-error": "hsl(8, 60%, 47%)",
    "--t-border-color-control-disabled": "hsl(0, 0%, 88%)"
};

export { tokens };
//# sourceMappingURL=tokens.js.map
